import { Component, OnInit } from '@angular/core';
import { DialogService } from 'src/app/service/dialog-service';
import { FormArray, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ApplicantService } from 'src/app/service/applicant.service';
import { Router } from '@angular/router';
import { CookiesLocalService } from 'src/app/service/cookies-local.service';
import { BehaviorModelChangeService } from 'src/app/service/behavior-model-change.service.service';
import { ComponentBase } from 'src/app/base/component-base';
import { UtilService } from 'src/app/service/util.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-list-research-experience',
  templateUrl: './list-research-experience.component.html',
  styleUrls: ['./list-research-experience.component.css']
})
export class ListResearchExperienceComponent  extends ComponentBase implements OnInit {
  mainForm: FormGroup;
  title: string;
  maxiumNumberOfItems = 10;

  constructor(private router: Router, private fb: FormBuilder, private utilService: UtilService
    ,         applicantService: ApplicantService, cookieLocal: CookiesLocalService, private toastr: ToastrService,
              behaviorModelChangeService: BehaviorModelChangeService, private dialogService: DialogService) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }

  ngOnInit() {
    console.log('list of research');

    this.title = 'JOURNAL / CONFERENCE OR ANY PEER REVIEWED DOCUMENT(S)';
    this.mainForm = this.fb.group({
      Caption: [''],
      ApplicantItems: this.fb.array([])
    });
    this.buildApplicantItems();
  }

  goToNext(form: any) {
    // if (this.save(form)) {
      // Navigate to the work page
      this.router.navigate(['/applicant/info/post-programme']);
   // }
  }

  goToPrevious(form: any) {
    this.router.navigate(['/applicant/info/post-work-experience']);
  }


  onAddItemClick(): void {
    const control = this.mainForm.controls.ApplicantItems as FormArray;
    const currentNumberOfExam = control.controls.length;

    if (currentNumberOfExam >= this.maxiumNumberOfItems) {
      this.toastr.warning(`Sorry you can only apply with (${this.maxiumNumberOfItems}) examinations`);
    } else {
    control.push(this.InitApplicantItems());
  }

  }

  buildApplicantItems() {

    const control = this.mainForm.controls.ApplicantItems as FormArray;
    this.applicantService.getApplicantResearchExperiencesByApplicantId(this.applicantData.ApplicationId)
    .subscribe(data => {
      data.forEach(item => {
       control.push(this.InitApplicantItems(item));
      });

    });
  }


  InitApplicantItems(data: any= null) {

    if (data) {
      const appCert = this.fb.group({
        ApplicationId: [this.applicantData.ApplicationId],
        ApplicantResearchExperienceId: [data.ApplicantResearchExperienceId],
        NameOfAuthors: [data.NameOfAuthors, Validators.required],
        JournalName: [data.JournalName, Validators.required],
        TitleOfPaper: [data.TitleOfPaper, Validators.required],
        DateOfPublication: [data.DateOfPublication, Validators.required],
        FileAttachedName: [data.FileAttachedName],
      });

      return appCert;
    } else {
      const appCert = this.fb.group({
        ApplicationId: [this.applicantData.ApplicationId],
        ApplicantResearchExperienceId: [0],
        NameOfAuthors: ['', Validators.required],
        JournalName: ['', Validators.required],
        TitleOfPaper: ['', Validators.required],
        DateOfPublication: ['', Validators.required],
        FileAttachedName: [''],
      });

      return appCert;
    }

  }


  isFormValid() {
    const ctl = (this.mainForm.get('ApplicantItems') as FormArray);
    return this.mainForm.valid && ctl.length >= 0;
  }

  getApplicantItemsArray(form) {
    return   form.controls.ApplicantItems.controls;
  }


  onSaveItemClick(item, index) {

    this.applicantService.saveApplicantResearchExperience(item.value).subscribe(data => {
      (this.mainForm.get('ApplicantItems') as FormArray).at(index).value.ApplicantResearchExperienceId = data.Id;

      this.toastr.success('Research Experience saved successfully');
    }, error => {
      console.log(error);
    });

  }




  onRemoveItemClick(index) {
    const data = (this.mainForm.get('ApplicantItems') as FormArray).at(index).value;
    if (data.ApplicantResearchExperienceId > 0) {
      this.dialogService.openConfirmDialog('Are you sure you want to delete this?').afterClosed().subscribe(d => {
        this.applicantService.removeApplicantResearchExperience(data.ApplicantResearchExperienceId).subscribe(data => {
            (this.mainForm.get('ApplicantItems') as FormArray).removeAt(index);
            this.toastr.success('Research Experience removed successfully');

        }, error => {
          console.log(error);
        });

      });

    } else {
      (this.mainForm.get('ApplicantItems') as FormArray).removeAt(index);

    }
  }
}
